module.exports = __webpack_public_path__ + "img/20-DEBITTAGE-min.0d1b8271.jpg";